import React from 'react'

import {
  Spinner,
  Icon,
  InfoOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'
import Tooltip from 'Pods/Shared/Tooltip'

import { renderMoneyValue, renderPercentage } from '../../formatter'
import { useMonthlySummary } from '../../Hooks/useMonthlySummary'
import EmptyMessage from '../EmptyMessage'

const earningRateTitle = (value) => (
  <span style={{ whiteSpace: 'nowrap' }}>{value}</span>
)

const renderDate = (value) => {
  if (value === 'Last 12 months') {
    return (
      <div className="data-tooltip-container">
        <strong>{value}</strong>
        <Tooltip
          content="This field shows your sales from the past 365 days"
          id="past-365-days"
        >
          <Icon
            svgComponent={InfoOutlined}
            color="dark"
            size="small"
            className="data-tooltip-container__icon"
          />
        </Tooltip>
      </div>
    )
  }

  return value
}

const renderBold = (renderFunction) => {
  function boldRenderer(value, row) {
    if (row.date === 'Last 12 months') {
      return (
        <strong>{renderFunction ? renderFunction(value, row) : value}</strong>
      )
    }

    return renderFunction ? renderFunction(value, row) : value
  }

  return boldRenderer
}

const columnsConfig = {
  id: { visible: false },
  yearMonth: { visible: false },
  date: { title: 'Date', position: 1 },
  sales: { title: 'Sales', position: 2 },
  downloads: { title: 'Downloads', position: 3 },
  soldFor: { title: 'Sales ($) ', position: 4 },
  earningRate: { title: earningRateTitle('Avg. Earning Rate'), position: 5 },
  revenue: { title: 'Earnings', position: 6 },
  donations: { title: 'Donations', position: 7 },
  finalEarnings: { title: 'Final Earnings', position: 8 },
  subscriptionEarnings: { title: 'Subscription Earnings', position: 9 },
}

function MonthlySummary() {
  const { monthlySummary, isLoading } = useMonthlySummary()

  const customCellRenderers = {
    revenue: renderBold(renderMoneyValue),
    subscriptionEarnings: renderBold(renderMoneyValue),
    donations: renderBold(renderMoneyValue),
    earningRate: renderBold(renderPercentage),
    date: renderBold(renderDate),
    sales: renderBold(),
    soldFor: renderBold(renderMoneyValue),
    downloads: renderBold(),
    finalEarnings: renderBold(renderMoneyValue),
  }

  return isLoading ? (
    <div className="spinner-container">
      <Spinner />
    </div>
  ) : (
    <LegacyDataTable
      data={monthlySummary}
      columnsConfig={columnsConfig}
      EmptyMessage={<EmptyMessage title="No monthly summary available!" />}
      renderCustomCell={customCellRenderers}
    />
  )
}

export default MonthlySummary
